import * as React from 'react';
import cx from 'clsx';

import { isActive } from '../constants';
import { BottomNavigationItem } from '../types';

import styles from './BottomNavigationSlot.module.scss';

interface BottomNavigationSlotProps {
  item: BottomNavigationItem;
}

const BottomNavigationSlot = ({ item }: BottomNavigationSlotProps) => {
  const { state, image, title, notification } = item;

  return (
    <div className={styles.slotContainer} data-testid="bottom-slot-container">
      <div
        className={cx(
          styles.icon,
          state === 'active' ? styles.iconActive : styles.iconInactive
        )}
        data-testid="icon"
        style={{
          maskImage: `url(${image.source})`,
          WebkitMaskImage: `url(${image.source})`,
        }}
      ></div>
      <div className={styles.notification}>{notification}</div>
      <p
        className={cx(
          styles.title,
          isActive(state) ? styles.titleActive : styles.titleInactive
        )}
        data-testid="title"
      >
        {title}
      </p>
    </div>
  );
};

export default BottomNavigationSlot;
